import { createFileRoute } from '@tanstack/react-router'

import { store } from '@/state/breadcrumb-store'
import { CustomerDashboard } from "@/components/customer/dashboard"

export const Route = createFileRoute('/')({
  component: Index,
})

const Index = () => {
  store.trigger.changePath({
    newPath:
      [{ params: {}, to: "/customer", label: "Customer" }]
  })
  return (
    <CustomerDashboard></CustomerDashboard>
  )
}

